import React from 'react';
import ReactDOM from 'react-dom';
import { Meteor } from 'meteor/meteor';
import Moment from 'react-moment';
import moment from 'moment';

import {
  Col,
  BPanel,
  Radio,
  FormGroup,
  FormControl,
  ControlLabel,
  Modal,
  Button
} from '@sketchpixy/rubix';
var DatePicker = require("react-bootstrap-date-picker");

import { cancelFlight } from '../../collections/flights/methods';

export class PlanningAnnuleModal extends React.Component {
  
  constructor(props) {
      super(props);
      this.state = {};
      this.state.showModal = false;
  }

  closeModal() {
    this.setState({ showModal: false });
  }
 
  openModal() {
    this.setState({ showModal: true });
  }

  cancel() {

	cancelFlight.call({
		_id: this.props.flight._id,
		reason: ReactDOM.findDOMNode(this.refs.reason).value.trim()
	}, ((err) => {
		if (err)
			return Messenger().post({
				message: err,
				type: "error"
			});
		
		Messenger().post({
			message: "Le vol a bien été annulé et les passagers ont été prévenus par SMS",
			type: "success"
		});
		
		this.closeModal();
		this.props.onCancel && this.props.onCancel();
	}).bind(this));
  }

  renderModal() {
    return (
      <Modal show={this.state.showModal} onHide={::this.closeModal}>
        <Modal.Header closeButton>
			<Modal.Title>Annulation du vol du { moment(this.props.flight.date).format("DD/MM/YYYY") } - { this.props.flight.getPeriod() } - { this.props.flight.getPlace() }</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <strong>Informations d'annulation :</strong><br/><br/>
            <FormGroup controlId="formControlsSelect">
                <Col sm={5}><ControlLabel>Raison de l'annulation :</ControlLabel></Col>
                <Col sm={7}>
					<FormControl type="text" ref="reason" />
                </Col>
            </FormGroup> 
           <br/><br/>
        </Modal.Body>
        <Modal.Footer>
            <Button bsStyle="danger" onClick={::this.cancel}>Annuler</Button>
        </Modal.Footer>
      </Modal>
    );
  
  }

  render() {
    if(this.state.showModal) {
      return (
        <div>
          {this.renderModal()}
        </div>
      );
    } else {
      return (
          <Button bsStyle="danger" onClick={this.openModal.bind(this)}>Annuler</Button>
      );
    }
  }

}

PlanningAnnuleModal.contextTypes = {
  router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/flights/PlanningAnnuleModal.js
 **/